import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["__typename"],
  _excluded2 = ["__typename"];
var parseBundles = function parseBundles(bundles) {
  return bundles.map(function (_ref) {
    var id = _ref.id,
      quantity = _ref.quantity,
      price = _ref.price,
      _ref$dimensions = _ref.dimensions,
      __typename = _ref$dimensions.__typename,
      dimensions = _objectWithoutProperties(_ref$dimensions, _excluded);
    return {
      dimensions: _extends({}, dimensions),
      id: id,
      price: price,
      quantity: quantity
    };
  });
};
var parseShippingVariables = function parseShippingVariables() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref2$pageName = _ref2.pageName,
    pageName = _ref2$pageName === void 0 ? '' : _ref2$pageName,
    _ref2$product = _ref2.product,
    product = _ref2$product === void 0 ? {} : _ref2$product,
    _ref2$structure = _ref2.structure,
    structure = _ref2$structure === void 0 ? {} : _ref2$structure,
    _ref2$customZipCode = _ref2.customZipCode,
    customZipCode = _ref2$customZipCode === void 0 ? '' : _ref2$customZipCode;
  var _product$price = product.price,
    _product$price2 = _product$price === void 0 ? {} : _product$price,
    fullPrice = _product$price2.fullPrice,
    listPrice = _product$price2.price,
    currency = _product$price2.currency,
    exchangeRate = _product$price2.exchangeRate,
    idExchangeRate = _product$price2.idExchangeRate,
    originalPriceForeign = _product$price2.originalPriceForeign,
    _product$seller = product.seller,
    _product$seller2 = _product$seller === void 0 ? {} : _product$seller,
    _product$seller2$id = _product$seller2.id,
    sellerId = _product$seller2$id === void 0 ? '' : _product$seller2$id,
    _product$seller2$cate = _product$seller2.category,
    sellerCategory = _product$seller2$cate === void 0 ? '1p' : _product$seller2$cate,
    _product$seller2$sku = _product$seller2.sku,
    sellerSku = _product$seller2$sku === void 0 ? '' : _product$seller2$sku,
    _product$variationId = product.variationId,
    variationId = _product$variationId === void 0 ? '' : _product$variationId,
    _product$type = product.type,
    type = _product$type === void 0 ? '' : _product$type,
    _product$bundles = product.bundles,
    bundles = _product$bundles === void 0 ? [] : _product$bundles,
    _product$dimensions = product.dimensions,
    _product$dimensions2 = _product$dimensions === void 0 ? {} : _product$dimensions,
    __typename = _product$dimensions2.__typename,
    dimensions = _objectWithoutProperties(_product$dimensions2, _excluded2);
  var price = fullPrice || listPrice;
  var _structure$cookies = structure.cookies,
    _structure$cookies2 = _structure$cookies === void 0 ? {} : _structure$cookies,
    _structure$cookies2$l = _structure$cookies2.location,
    _structure$cookies2$l2 = _structure$cookies2$l === void 0 ? {} : _structure$cookies2$l,
    _structure$cookies2$l3 = _structure$cookies2$l2.zipCode,
    zipcode = _structure$cookies2$l3 === void 0 ? '' : _structure$cookies2$l3,
    _structure$cookies2$a = _structure$cookies2.accountData,
    _structure$cookies2$a2 = _structure$cookies2$a === void 0 ? {} : _structure$cookies2$a,
    _structure$cookies2$a3 = _structure$cookies2$a2.id,
    clientId = _structure$cookies2$a3 === void 0 ? '' : _structure$cookies2$a3,
    _structure$config = structure.config,
    config = _structure$config === void 0 ? {} : _structure$config,
    _structure$route = structure.route,
    _structure$route2 = _structure$route === void 0 ? {} : _structure$route,
    _structure$route2$cat = _structure$route2.categoryId,
    categoryId = _structure$route2$cat === void 0 ? '' : _structure$route2$cat,
    _structure$route2$sub = _structure$route2.subCategoryId,
    subcategoryId = _structure$route2$sub === void 0 ? '' : _structure$route2$sub,
    _structure$route2$par = _structure$route2.partner_id,
    partnerId = _structure$route2$par === void 0 ? '0' : _structure$route2$par;
  var parsePartnerId = function parsePartnerId(partnerIdParam) {
    if (Array.isArray(partnerIdParam)) return partnerIdParam[0];
    return partnerIdParam;
  };
  return {
    metadata: {
      categoryId: categoryId,
      clientId: clientId,
      organizationId: 'magazine_luiza',
      pageName: pageName,
      partnerId: parsePartnerId(partnerId),
      salesChannelId: config.salesChannelId,
      sellerId: sellerId,
      subcategoryId: subcategoryId
    },
    product: _extends({
      currency: currency,
      dimensions: _extends({}, dimensions),
      exchangeRate: parseFloat(exchangeRate),
      id: sellerCategory === '1p' ? variationId : sellerSku,
      idExchangeRate: String(idExchangeRate),
      originalPriceForeign: parseFloat(originalPriceForeign),
      price: parseFloat(price),
      quantity: 1,
      type: type
    }, type === 'bundle' && (bundles == null ? void 0 : bundles.length) > 0 && {
      bundles: parseBundles(bundles)
    }),
    zipcode: customZipCode || zipcode
  };
};
export default parseShippingVariables;